module.exports = __webpack_public_path__ + "static/desktop-5caddf95666deddb9b2da56f50872bd9.mp4";